import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Typography, Divider } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import _, { omit, pick, round, slice } from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    imageList: {
        width: 1000,
        height: "auto",
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    section2: {
        margin: theme.spacing(3, 2),
    },

}));


export default function TitlebarImageList(props) {
    const MedirepURL = "http://medirep.mornjoy.com.tw";
    // const [DataSourceObj, setDataSourceObj] = React.useState({})

    const { DataSource, setPicObj, ItemName, ItemNo } = props;
    const classes = useStyles();
    const ShowPic = (e, img) => {
        e.preventDefault();
        e.stopPropagation();
        // console.log(img)
        setOpen(true);
        setDialogImg(img);
    }
    const [DialogImg, setDialogImg] = React.useState("")
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        // setSelectedValue(value);
    };
    const handleDeleteImg = (e, picNo, imgString) => {
        e.preventDefault();
        e.stopPropagation();
        let isconfirm = window.confirm("確定是否刪除該張圖片?");
        if (isconfirm) {
            console.log(picNo, imgString);
            setPicObj(prev => ({
                ...prev,
                [picNo]: _.remove(prev[picNo], (item) => item !== imgString)
            }))

        }



    }


    return (

        <div>

            <div className={classes.section2}>
                {/* <div key="Subheader" style={{ paddingTop: "30px", display: "block" }}>
                    <Typography variant="h4" >{ItemName[ItemNo]}</Typography>
                </div> */}
                < ImageList rowHeight={180} cols={5} className={classes.imageList} >
                    {

                        DataSource["pic_" + ItemNo]?.length > 0 ? (DataSource["pic_" + ItemNo]).map((item, index) => {
                            return (
                                < ImageListItem key={index} >
                                    <img loading="lazy" style={{ cursor: "pointer" }} src={MedirepURL + item} alt={item.title} onClick={e => ShowPic(e, MedirepURL + item)} />
                                    <ImageListItemBar
                                        classes={{
                                            root: classes.titleBar,
                                            title: classes.title,
                                        }}
                                        // title={item.title}
                                        // subtitle={<span>by: {item.author}</span>}
                                        actionIcon={
                                            <IconButton aria-label={`info about ${item.title}`} className={classes.icon} onClick={e => handleDeleteImg(e, "pic_" + ItemNo, item)}>
                                                <InfoIcon />
                                            </IconButton>
                                        }
                                    />
                                </ImageListItem>)
                        }) : null
                    }
                </ImageList>
                <Divider variant="middle" className={classes.section2} />
            </div>


            <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true}
                maxWidth={"xl"}>
                <DialogTitle onClose={handleClose}>
                    <Typography>圖片檢視</Typography>
                    <IconButton className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <img src={DialogImg} loading="lazy" />
                </DialogContent>
                {/* <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Save
                    </Button>
                </DialogActions> */}
            </Dialog>

        </div >
    );
}